import type {
  APIComponentAttributes,
  APIComponentType,
  ArdoqId,
} from '@ardoq/api-types';
import {
  type ComponentRepresentationData,
  getComponentTypeRepresentationDataFromComponentType,
} from '@ardoq/basic-components';
import type {
  EnhancedScopeData,
  WorkspaceAndModelLookup,
} from '@ardoq/data-model';
import { componentUtils } from '@ardoq/scope-data';
import { resolveComponentType } from './resolveComponentTypeFromWorkspaceAndModel';

const toRepresentationDataByComponentId = (
  componentIds: ArdoqId[],
  resolveComponentType: (componentId: ArdoqId) => APIComponentType | null
): Map<ArdoqId, ComponentRepresentationData | null> =>
  new Map(
    componentIds.map(id => {
      const componentType = resolveComponentType(id);
      return [
        id,
        componentType
          ? getComponentTypeRepresentationDataFromComponentType(componentType)
          : null,
      ];
    })
  );

export const buildComponentRepresentationDataByComponentId = (
  componentIds: ArdoqId[],
  componentsById: Record<ArdoqId, APIComponentAttributes>,
  workspaceAndModel: WorkspaceAndModelLookup
): Map<ArdoqId, ComponentRepresentationData | null> =>
  toRepresentationDataByComponentId(componentIds, id => {
    const component = componentsById[id];
    return component
      ? resolveComponentType(component, workspaceAndModel)
      : null;
  });

export const buildComponentRepresentationDataByComponentIdFromScopeData = (
  componentIds: ArdoqId[],
  enhancedScopeData: EnhancedScopeData
): Map<ArdoqId, ComponentRepresentationData | null> =>
  toRepresentationDataByComponentId(componentIds, id =>
    componentUtils.getType(enhancedScopeData, id)
  );
